(function () {
  function init(root) {
    if (!root || root.dataset.homeInitialized === 'true') return;
    root.dataset.homeInitialized = 'true';

      const revealTargets = [
        '.home-after-buy-copy > *',
        '.home-cycle-panel',
        '.home-cycle-timeline li'
      ];
      const revealItems = revealTargets.flatMap((selector) => Array.from(root.querySelectorAll(selector)));
      revealItems.forEach((item, index) => {
        item.classList.add('home-reveal-item');
        if (item.matches('.home-menoplay-stage, .home-menotest-visual, .home-doctor-visual, .home-cycle-panel, .home-final-cta')) {
          item.classList.add('home-reveal-scale');
        }
        item.style.setProperty('--home-reveal-delay', `${Math.min(index % 8, 6) * 70}ms`);
      });
      const sectionRevealItems = Array.from(root.querySelectorAll('.home-section-reveal'));
      root.querySelectorAll('.home-cycle-timeline li').forEach((item, index) => {
        item.style.setProperty('--home-reveal-delay', `${index * 150}ms`);
      });
      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('home-is-visible'); });
        }, { threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
        const sectionRevealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('home-is-visible');
              sectionRevealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -12% 0px' });
        root.classList.add('home-reveal-motion-ready');
        window.setTimeout(() => {
          revealItems.forEach((item) => revealObserver.observe(item));
          sectionRevealItems.forEach((item) => sectionRevealObserver.observe(item));
        }, 120);
      } else {
        revealItems.forEach((item) => item.classList.add('home-is-visible'));
        sectionRevealItems.forEach((item) => item.classList.add('home-is-visible'));
      }

      const timeline = root.querySelector('.home-cycle-timeline');
      const svg = timeline?.querySelector('.home-cycle-journey-path');
      const path = svg?.querySelector('path');
      const cards = timeline ? Array.from(timeline.querySelectorAll('li')).slice(0, 5) : [];
      let resizeTimer;

      function updateJourneyPath() {
        if (!timeline || !svg || !path || cards.length !== 5 || window.matchMedia('(max-width: 47.5rem)').matches) return;

        const timelineRect = timeline.getBoundingClientRect();
        if (!timelineRect.width || !timelineRect.height) return;

        const points = cards.map((card, index) => {
          const rect = card.getBoundingClientRect();
          const edgeX = index % 2 === 0 ? rect.left : rect.right;
          return {
            x: ((edgeX - timelineRect.left) / timelineRect.width) * 520,
            y: (((rect.top + (rect.height / 2)) - timelineRect.top) / timelineRect.height) * 520
          };
        });
        const pointAt = (index) => points[Math.max(0, Math.min(points.length - 1, index))];
        const coordinate = (value) => Number(value.toFixed(2));
        const curveStrength = 0.34;
        let d = `M${coordinate(points[0].x)} ${coordinate(points[0].y)}`;

        for (let index = 0; index < points.length - 1; index += 1) {
          const previous = pointAt(index - 1);
          const current = pointAt(index);
          const next = pointAt(index + 1);
          const following = pointAt(index + 2);
          const controlOne = {
            x: current.x + ((next.x - previous.x) * curveStrength),
            y: current.y + ((next.y - previous.y) * curveStrength)
          };
          const controlTwo = {
            x: next.x - ((following.x - current.x) * curveStrength),
            y: next.y - ((following.y - current.y) * curveStrength)
          };
          d += ` C${coordinate(controlOne.x)} ${coordinate(controlOne.y)} ${coordinate(controlTwo.x)} ${coordinate(controlTwo.y)} ${coordinate(next.x)} ${coordinate(next.y)}`;
        }

        path.setAttribute('d', d);
        path.style.animation = 'none';
        void path.getBoundingClientRect();
        path.style.removeProperty('animation');
      }

      function scheduleJourneyPathUpdate() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(updateJourneyPath, 120);
      }

      window.requestAnimationFrame(() => window.requestAnimationFrame(updateJourneyPath));
      if (document.fonts?.ready) document.fonts.ready.then(scheduleJourneyPathUpdate);
      window.addEventListener('resize', scheduleJourneyPathUpdate);
    }
  const currentScript = document.currentScript;
  const section = currentScript?.closest('.shopify-section');
  init(section?.querySelector('[data-home-authoritative]'));
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target?.querySelector?.('[data-home-authoritative]'));
  });
}());
